export class ApiError extends Error {
  status: number;
  code: string;
  message_ar?: string;
  body: unknown;
  constructor(status: number, body: { error?: string; message_ar?: string } | null) {
    super(body?.message_ar ?? body?.error ?? `HTTP ${status}`);
    this.status = status;
    this.code = body?.error ?? 'http_error';
    this.message_ar = body?.message_ar;
    this.body = body;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const r = await fetch(path, {
    method,
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'same-origin',
  });
  const text = await r.text();
  let json: unknown = null;
  try { json = text ? JSON.parse(text) : null; } catch { json = null; }
  if (!r.ok) throw new ApiError(r.status, json as { error?: string; message_ar?: string } | null);
  return json as T;
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  put: <T>(path: string, body?: unknown) => request<T>('PUT', path, body),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
};

export type PlanCode = 'single' | 'morning' | 'basic' | 'full' | 'weekly' | 'custom';

export type PlanView = {
  id: string; code: PlanCode; name: string; description: string; visits: number; services?: string[];
  price_halalas: number; price_label: string; min_gap_days: number; window: { start_min: number; end_min: number } | null; includes_beard: boolean;
  rollover_max: number; rollover_line: string;
};

export type ShopPublic = {
  slug: string; name: string; district: string | null; phone: string | null; moyasar_pk: string | null;
  cr_number: string | null; vat_registered: boolean; renewal_mode: 'auto' | 'link';
};

export function sar(halalas: number) {
  const v = halalas / 100;
  return Number.isInteger(v) ? String(v) : v.toFixed(2);
}

/** "149 ريالًا شاملًا ..." -> number part only, for big display */
export function priceNumber(label: string) {
  return label.split(' ')[0] ?? label;
}
export function priceSuffix(label: string) {
  return label.split(' ').slice(1).join(' ');
}

export function clock(min: number) {
  const h = Math.floor(min / 60);
  const suffix = h < 12 ? 'صباحًا' : h < 17 ? 'ظهرًا' : 'مساءً';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12} ${suffix}`;
}

export function dateAr(iso: string | null | undefined) {
  if (!iso) return '';
  const d = new Date(new Date(iso).getTime() + 3 * 3600_000);
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

export function idem() {
  const a = new Uint8Array(12);
  crypto.getRandomValues(a);
  return [...a].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export const STATUS_AR: Record<string, string> = {
  active: 'فعّالة', cancel_at_period_end: 'تنتهي آخر الدورة', past_due: 'بانتظار التجديد', canceled: 'ملغاة', withdrawn: 'تم العدول', pending: 'محجوزة، تُفعَّل عند الدفع',
};

export type PaymentsMode = 'live' | 'mock' | 'counter';
